var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tooltip-btn"},[_c('div',{staticClass:"tooltip-btn__ico"},[_c('TooltipIco')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }